import React from "react";
import { useNavigate } from "react-router-dom";
import "./AboutPreview.css";

const AboutPreview = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/about");
  };

  return (
    <div className="about-preview">
      <div className="about-content">
        <h2 className="fade-in">Who We Are</h2>
        <p className="fade-in">
          At Apco Lighting, we combine architecture and innovation to create high-performance,
          sustainable lighting solutions that illuminate spaces with elegance and purpose.
        </p>
        <button className="learn-more-btn fade-in" onClick={handleLearnMore}>
          Learn More
        </button>
      </div>
    </div>
  );
};

export default AboutPreview;
